<template>
  <div
    class="phone-section flex-c"
    v-if="
      (Array.isArray(profileData.phone) && profileData.phone.length > 0) ||
      (contactId &&
        !(
          Array.isArray(profileData.phone) && profileData.phone.length === 0
        )) ||
      (profileData.fullName &&
        profileData.companyName &&
        !(Array.isArray(profileData.phone) && profileData.phone.length === 0) &&
        email &&
        !errorMsg)
    "
  >
    <Phone-Icon
      class="ref-icon"
      width="18px"
      height="18px"
      viewBox="0 0 20 20"
    />
    <div class="text-section flex-c">
      <span class="value noselect">
        {{ isPhonePurchased() ? profileData.phone[0] : '*-**-*-***-****' }}
      </span>
      <div
        class="show-more"
        v-if="isPhonePurchased() && profileData.phone.length > 1"
        v-click-outside="hideDropdown"
      >
        <span @click="showMoreDropdown = !showMoreDropdown"
          >+{{ profileData.phone.length - 1 }} more</span
        >
        <div class="dropdown" v-if="showMoreDropdown">
          <div
            class="phone-section flex-c"
            v-for="ele in profileData.phone.slice(1)"
            :key="ele"
          >
            <Phone-Icon
              class="ref-icon"
              width="18px"
              height="18px"
              viewBox="0 0 20 20"
            />
            <div class="text-section flex-c">
              <span class="value noselect">{{ ele }} </span>
            </div>
            <div
              class="copy-wrap"
              title="Click to Copy"
              @click="
                copyClipboard(
                  profileData.mcId
                    ? profileData.mcId
                    : profileData.masterContactId,
                  ele,
                  'phone'
                )
              "
            >
              <input
                type="text"
                :value="profileData.phone"
                class="noVisibility"
                :id="
                  (profileData.mcId
                    ? profileData.mcId
                    : profileData.masterContactId) + 'phone'
                "
              />
              <Copy-Icon width="16" height="16" />
            </div>
          </div>
        </div>
      </div>

      <div class="copy-section" v-if="isPhonePurchased()">
        <div
          class="copy-wrap"
          title="Click to Copy"
          @click="
            copyClipboard(
              profileData.mcId ? profileData.mcId : profileData.masterContactId,
              profileData.phone[0],
              'phone'
            )
          "
        >
          <input
            type="text"
            :value="profileData.phone"
            class="noVisibility"
            :id="
              (profileData.mcId
                ? profileData.mcId
                : profileData.masterContactId) + 'phone'
            "
          />
          <Copy-Icon width="16" height="16" />
        </div>
      </div>
      <Button
        v-if="!isPhonePurchased()"
        className="view-phone"
        :callback="handleViewPhone"
        :text="'Request Mobile'"
        :loading="loading"
      ></Button>
    </div>
  </div>
</template>

<script>
import sharedFunctions from '@/assets/util/functions.js'
import phoneIcon from '@/assets/icons/svg/phone.svg'
import copyIcon from '@/assets/icons/svg/copy.svg'
import { post } from '@/assets/util/rest.js'
import button from '@/components/Button'
import { MxEvent } from '@/assets/util/constants/analytics'

export default {
  name: 'PhoneSection',
  props: [
    'profileData',
    'updatePhone',
    'showUpgradePopup',
    'email',
    'errorMsg',
    'contactId',
    'pageName',
  ],
  data: function () {
    return {
      loading: false,
      showMoreDropdown: false,
    }
  },
  components: {
    'Phone-Icon': phoneIcon,
    'Copy-Icon': copyIcon,
    Button: button,
  },
  methods: {
    hideDropdown() {
      this.showMoreDropdown = false
    },
    copyClipboard(cId, mail, name) {
      if (this.isPhonePurchased()) {
        let txtDisplay = 'Copied'
        const dataMap = {
          pageType: 'Single',
        }
        sharedFunctions.clickToCopy(
          cId,
          mail,
          name,
          null,
          dataMap,
          txtDisplay,
          this.$store.state
        )
      }
    },
    handleViewPhone() {
      if (this.$store.state.header.mobileNumberEnabled) {
        this.loading = true
        const url = 'lp/findPhone.htm'

        const data = {
          contactId: this.profileData.mcId || this.profileData.masterContactId,
        }
        data.fullName = this.profileData.fullName
        if (this.profileData.isSalesNavigator || !this.profileData.linkedinId) {
          data.companyName = this.profileData.companyName
        } else {
          data.liUrl = this.profileData.linkedinId
        }
        post(url, data)
          .then((response) => {
            response.json().then((result) => {
              this.loading = false
              console.log(result)
              if (result.statusCode === 200) {
                if (!result.phoneNumbers || result.phoneNumbers.length === 0) {
                  sharedFunctions.showNotificationMsg(
                    'Sorry, we are unable to find mobile number',
                    3000
                  )
                  this.updatePhone(result.phoneNumbers || [])
                } else {
                  sharedFunctions.track(
                    this.$store.state.isSalesNavigator
                      ? MxEvent.mobileNumberPurchasedSN
                      : MxEvent.mobileNumberPurchased,
                    {
                      contactId: this.contactId,
                      contactName: this.profileData.fullName,
                      companyName: this.profileData.companyName,
                      pageName: this.pageName,
                    },
                    this.$store.state
                  )
                  this.updatePhone(result.phoneNumbers)
                  this.$store.state.header.phoneCredits =
                    result.remainingPhoneCredits
                }
              } else if (result.statusCode === 402) {
                this.showUpgradePopup('phone')
              } else {
                sharedFunctions.showNotificationMsg(
                  'Sorry, we are unable to find mobile number',
                  3000
                )
                this.updatePhone([])
              }
            })
          })
          .catch((e) => {
            console.log('error: ', e)
          })
      } else {
        this.showUpgradePopup(
          this.$store.state.header.isPaidUser &&
            this.$store.state.header.userType === 'PAID'
            ? 'phone_locked'
            : 'phone_free_user'
        )
      }
    },
    isPhonePurchased() {
      return this.profileData.phone && this.profileData.phone.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.phone-section {
  margin-bottom: 20px;

  .ref-icon {
    stroke: #667080;
  }
  ::v-deep {
    .text-section > div {
      margin-left: auto;
    }
    .view-phone {
      width: 102px;

      font-size: 12px;
      line-height: 18px;
      background: rgba(38, 72, 247, 0.05);
      border: 1.5px solid rgba(38, 72, 247, 0.2);
      border-radius: 6px;
      color: #2648f7;
      position: relative;
      border-width: 1px;
      padding: 2px 8px;

      &:hover {
        background: #2648f7;
        border-color: #2648f7;
        color: #fff;
      }
    }
  }
  .copy-wrap {
    border-radius: 6px !important;
  }

  .text-section {
    position: relative;
    padding-left: 10px;
    width: 100%;
    line-height: initial;

    .show-more {
      display: inline-block;
      margin-left: 5px;
      font-size: 12px;
      position: relative;
      > span {
        color: $primary-color;
        cursor: pointer;
      }

      .dropdown {
        color: initial;
        position: absolute;
        top: 100%;
        left: -30px;
        background: #fff;
        box-shadow: 0 3px 10px rgba(102, 112, 128, 0.2);
        border-radius: 8px;
        padding: 4px;
        width: 180px;
        max-height: 200px;
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 2;
        .phone-section {
          padding: 10px 5px;
          margin-bottom: 0;
          &:hover {
            background: #f6f6f9;
          }
        }
        .copy-wrap {
          cursor: pointer;
        }
      }
    }
    .value {
      color: $grey-text;
      word-break: break-all;
      font-size: 15px;
      line-height: 20px;
    }
    .copy-section::v-deep {
      margin-left: auto;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      transition: all 300ms ease;

      .copy-wrap {
        position: relative;
        background: #ffffff;
        border: 1px solid rgba(102, 112, 128, 0.2);
        border-radius: 6px 0px 0px 6px;
        width: 34px;
        height: 28px;
        display: flex;
        justify-content: center;
        margin-right: -1px;
        align-items: center;
        cursor: pointer;
        transition: all 300ms ease;

        &:hover svg g {
          opacity: 1;
          stroke: $primary-color;
        }
        &:hover {
          z-index: 1;
          border-color: $primary-color;
        }
        input {
          border: none;
          width: 100%;
          height: 1px;
          opacity: 0;
          box-shadow: none;
          outline: none;
          position: absolute;
          top: 10px;
          left: 5px;
          z-index: -1;
        }
      }
    }
  }
}
</style>
